import { isRecord } from './normalize.ts';
import { getStepType } from './step-types.ts';
import type { Step } from './types.ts';

export function answerKeys(step: Step): string[] {
  const spec = getStepType(step.type);
  if (spec?.answers === 'yes_no') return ['yes', 'no'];
  if (spec?.answers === 'options' && Array.isArray(step['options'])) {
    return step['options'].filter(isRecord).map((o) => String(o['value']));
  }
  return [];
}

export function targetsOf(step: Step): string[] {
  const next = step.next;
  if (next === undefined) return ['next'];
  if (typeof next === 'string') return [next];
  if (Array.isArray(next)) {
    const out: string[] = [];
    let hasOtherwise = false;
    for (const branch of next) {
      if (!isRecord(branch)) continue;
      if (typeof branch['goto'] === 'string') out.push(branch['goto']);
      if (typeof branch['otherwise'] === 'string') {
        out.push(branch['otherwise']);
        hasOtherwise = true;
      }
    }
    if (!hasOtherwise) out.push('next');
    return out;
  }
  if (isRecord(next)) {
    const out = Object.values(next).filter((t): t is string => typeof t === 'string');
    const covered = answerKeys(step).every((k) => k in next);
    if (!covered) out.push('next');
    return out;
  }
  return ['next'];
}
